<script>
  import { fade } from 'svelte/transition';
  export let event;
</script>

<div class="event" in:fade>
  <div class="section-label">{event.name}</div>
  {@html event.description}
</div>